var render = function () {
  var _vm$form$vendor;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Admin',
        to: '/user-admin'
      }, {
        label: 'Add New'
      }],
      "title": "New Admin"
    }
  }), _c('div', {
    staticClass: "flex-col w-full mb-3 bg-white rounded-lg"
  }, [_c('div', {
    staticClass: "flex items-center justify-between w-full px-4 py-3 mt-3 rounded-lg"
  }, [_c('div', {
    staticClass: "flex flex-col w-1/2"
  }, [_c('FormLabel', {
    attrs: {
      "htmlFor": "email"
    }
  }, [_vm._v(" Email ")]), _c('TextInput', {
    attrs: {
      "type": "email",
      "id": "email",
      "placeholder": "Enter Email",
      "variant": _vm.isSubmitted && !_vm.form.email.trim() || _vm.emailAlreadyExists ? 'error' : 'default'
    },
    model: {
      value: _vm.form.email,
      callback: function ($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  }), _vm.isSubmitted && !_vm.form.email.trim() ? _c('div', {
    staticClass: "mt-1 text-sm text-red-500"
  }, [_vm._v("Email is required.")]) : _vm._e(), _vm.isSubmitted && _vm.form.email.trim() && _vm.emailAlreadyExists ? _c('div', {
    staticClass: "mt-1 text-sm text-red-500"
  }, [_vm._v("Email already exists.")]) : _vm._e(), _c('FormLabel', {
    attrs: {
      "htmlFor": "password",
      "className": "mt-3"
    }
  }, [_vm._v(" Password ")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextInput', {
    staticClass: "w-full pr-10 text-gray-400",
    attrs: {
      "type": _vm.showPassword ? 'text' : 'password',
      "id": "password",
      "disabled": "",
      "placeholder": "Enter Password",
      "variant": _vm.isSubmitted && _vm.isPasswordError ? 'error' : 'default'
    },
    model: {
      value: _vm.form.password,
      callback: function ($$v) {
        _vm.$set(_vm.form, "password", $$v);
      },
      expression: "form.password"
    }
  }), _c('button', {
    staticClass: "absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-gray-700",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleShowPassword
    }
  }, [!_vm.showPassword ? _c('EyeFilled', {
    attrs: {
      "className": "w-4 h-4"
    }
  }) : _c('EyeSlashFilled', {
    attrs: {
      "className": "w-4 h-4"
    }
  })], 1)], 1), _vm.isSubmitted && _vm.isPasswordError ? _c('div', {
    staticClass: "mt-1 text-sm text-red-500"
  }, [_vm._v("Must be filled.")]) : _vm._e(), _c('FormLabel', {
    attrs: {
      "htmlFor": "group",
      "className": "mt-3"
    }
  }, [_vm._v(" Group ")]), _c('SelectRadio', {
    attrs: {
      "id": "group",
      "defaultText": "Select Group",
      "options": _vm.groupOptions,
      "isError": _vm.isSubmitted && _vm.isGroupError
    },
    on: {
      "input": _vm.changeGroup
    },
    model: {
      value: _vm.form.group,
      callback: function ($$v) {
        _vm.$set(_vm.form, "group", $$v);
      },
      expression: "form.group"
    }
  }), _vm.form.group === 'publisher' ? _c('div', [_c('FormLabel', {
    attrs: {
      "htmlFor": "vendor",
      "className": "mt-3"
    }
  }, [_vm._v(" Publisher ")]), _c('multiselect', {
    staticClass: "box-border custom-multiselect",
    class: _vm.isSubmitted && _vm.isVendorError ? 'error' : '',
    attrs: {
      "label": "name",
      "track-by": "name",
      "placeholder": "Type to find publisher",
      "open-direction": "bottom",
      "options": _vm.vendorOptions,
      "searchable": true,
      "loading": _vm.isLoadingVendor,
      "close-on-select": true
    },
    on: {
      "search-change": _vm.handleSearchVendor
    },
    model: {
      value: _vm.form.vendor,
      callback: function ($$v) {
        _vm.$set(_vm.form, "vendor", $$v);
      },
      expression: "form.vendor"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v(" Oops! No elements found. Consider changing the search query. ")])]), _vm.isSubmitted && _vm.isVendorError ? _c('div', {
    staticClass: "mt-1 text-sm text-red-500"
  }, [_vm._v("Must be filled.")]) : _vm._e()], 1) : _vm._e(), _vm.form.group === 'publisher_group' ? _c('div', [_c('FormLabel', {
    attrs: {
      "htmlFor": "vendor",
      "className": "mt-3"
    }
  }, [_vm._v(" Publisher Group ")]), _c('multiselect', {
    staticClass: "box-border custom-multiselect",
    class: _vm.isSubmitted && _vm.isVendoGroupError ? 'error' : '',
    attrs: {
      "label": "name",
      "track-by": "name",
      "placeholder": "Type to find publisher",
      "open-direction": "bottom",
      "options": _vm.vendorGroupOption,
      "searchable": true,
      "loading": _vm.isLoadingVendorGroup,
      "close-on-select": true
    },
    on: {
      "search-change": _vm.handleSearchVendorGroup
    },
    model: {
      value: _vm.form.vendor_group,
      callback: function ($$v) {
        _vm.$set(_vm.form, "vendor_group", $$v);
      },
      expression: "form.vendor_group"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v(" Oops! No elements found. Consider changing the search query. ")])])], 1) : _vm._e(), _vm.isSubmitted && _vm.isVendoGroupError ? _c('div', {
    staticClass: "mt-1 text-sm text-red-500"
  }, [_vm._v("Must be filled.")]) : _vm._e(), _c('FormLabel', {
    attrs: {
      "htmlFor": "role",
      "className": "mt-3"
    }
  }, [_vm._v(" Role ID ")]), _c('SelectRadio', {
    class: !_vm.form.group ? 'opacity-50' : 'opacity-100',
    attrs: {
      "id": "role",
      "defaultText": "Select Role",
      "disabled": !_vm.form.group,
      "options": _vm.roleOption,
      "isError": _vm.isSubmitted && _vm.isRoleError
    },
    model: {
      value: _vm.form.role,
      callback: function ($$v) {
        _vm.$set(_vm.form, "role", $$v);
      },
      expression: "form.role"
    }
  }), _vm.isSubmitted && _vm.isRoleError ? _c('div', {
    staticClass: "mt-1 text-sm text-red-500"
  }, [_vm._v("Must be filled.")]) : _vm._e(), _c('FormLabel', {
    attrs: {
      "htmlFor": "status",
      "className": "mt-3"
    }
  }, [_vm._v(" Status ")]), _c('GmSwitch', {
    attrs: {
      "id": "status"
    },
    model: {
      value: _vm.form.isActive,
      callback: function ($$v) {
        _vm.$set(_vm.form, "isActive", $$v);
      },
      expression: "form.isActive"
    }
  }), _c('div', {
    staticClass: "flex gap-5 mt-4"
  }, [_c('Button', {
    attrs: {
      "disabled": _vm.isLoadingCreate
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v(" " + _vm._s(_vm.isLoadingCreate ? 'Saving...' : 'Save') + " ")]), _c('Button', {
    attrs: {
      "variant": "outlined",
      "color": "alternative"
    },
    on: {
      "click": _vm.cancelCreate
    }
  }, [_vm._v(" Cancel ")])], 1)], 1)])]), _c('ConfirmationModal', {
    attrs: {
      "visible": _vm.showConfirmation,
      "admin-count": _vm.existingAdminCount,
      "vendor-name": (_vm$form$vendor = _vm.form.vendor) === null || _vm$form$vendor === void 0 ? void 0 : _vm$form$vendor.name
    },
    on: {
      "update:visible": function ($event) {
        _vm.showConfirmation = $event;
      },
      "continue": _vm.proceedWithCreation,
      "cancel": _vm.cancelCreation
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }